import { useCurrentAddressInfo } from '@/hooks';
import { queryClient, request } from '@/utils';
import produce from 'immer';
import { useQuery } from 'react-query';

export type GroupMember = UserInfo & { inner_id: string; join_at: number; is_signer: boolean };

type GroupMemberListRes = {
  total_count: number;
  members: GroupMember[];
};

export const useGroupMemberList = (
  groupId: number,
  is_signer: boolean,
  pageNum: string,
  limit: number = 20,
) => {
  const url = '/group/members';

  const query = useQuery([url, groupId, is_signer, pageNum], () => {
    const params: any = {
      id: groupId,
      start: (Number(pageNum) - 1) * limit,
      limit,
    };
    if (is_signer) {
      params.is_signer = true;
    }
    return request.get<GroupMemberListRes>(url, params);
  });

  return query;
};

export const useSetGroupMember = (groupId: number) => {
  const { userInfo } = useCurrentAddressInfo();

  return ({ id, isFollowing }: { id: string; isFollowing: boolean }) => {
    queryClient.setQueriesData<{ members: GroupMember[] } | undefined>(
      ['/group/members', groupId],
      pre => {
        if (!pre) {
          return pre;
        }

        return produce(pre, draft => {
          const record = draft?.members?.find(x => x.id === id);

          if (record) {
            record.is_following = isFollowing;

            record.follower_count = isFollowing
              ? record.follower_count + 1
              : record.follower_count > 1
                ? record.follower_count - 1
                : 0;

            const usdValue = userInfo?.desc?.usd_value || 0;
            record.tvf = isFollowing ? record.tvf + usdValue : record.tvf - usdValue;

            if (record.tvf < 0) {
              record.tvf = 0;
            }
          }
        });
      },
    );
  };
};
